<template>
  <div id="demfor-charts" class="mb-base">
    <!-- <pre>{{artefact}}</pre> -->
    <!-- <vx-card title="Overall Sale Trend ( Actual vs Forecast ) &amp; Top categories ( Forecast )" subtitle="Sale by Week"> -->
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
        <vx-card title="Demand Forecast & Actuals">
          <!-- <div slot="no-body" class="p-6 pb-0 pt-0 w-full mb-base"> -->
          <div id="chart1">
            <apexchart type="line" height="230" :options="chartOptionsArea" :series="series" />
          </div>
          <div id="chart2">
            <apexchart type="area" height="130" :options="chartOptionsBrush" :series="series" />
          </div>
        </vx-card>
        </div>
        <!-- <div class="vx-col w-full md:w-1/2 lg:w-1/2 mb-2">
        <vx-card title="Lost opportunity by categories ( Top 10 )">
           <vue-apex-charts
              type="bar"
              height="375"
              :options="topUnits[type].chartOptions"
              :series="topUnits[type].seriesData"
          ></vue-apex-charts>
        </vx-card>
          </div> -->
      </div>
    <!-- </vx-card> -->
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

import appConfig from "@/../appConfig.js";
import { appCommons } from "@/app/shared/services";
import { fetchMock } from "../shared/services";

const themeColors = appConfig.chart.colors;
const brushStart = appCommons.allowedDateScope("", 10, 'minus').startDate;
const brushEnd = appCommons.allowedDateScope("", 10, 'plus').endDate;

export default {
  props: {
    artefact: { type: Object, required: true },
    type: { type: String, required: true }
  },
  components: {
    VueApexCharts,
  },
  data() {
    return {
      payload: {
        tags: [],
        dateRange: {},
        query: "",
        mode: "",
        type: "",
      },
      series: [],
      chartOptionsArea: {
        chart: {
          id: "chartArea",
          toolbar: {
            autoSelected: "pan",
            show: false,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        stroke: {
          curve: "smooth",
          dashArray: [4, 0, 4, 0, 4, 0],
          width: [2, 2, 2, 2, 2, 2],
        },
        grid: {
          show: false,
          borderColor: "#e7e7e7",
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'right'
        },
        colors: ["#C8513C", themeColors[0]],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            inverseColors: false,
            gradientToColors: ["#C8513C", themeColors[0]],
            shadeIntensity: 1,
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100],
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 3,
          hover: {
            size: 5,
          },
        },
        xaxis: {
          type: "datetime",
          tickAmount: 15,
          title: {
            // offsetY: 10,
            // text: "Week",
          },
          labels: {
            hideOverlappingLabels: true,
            style: {
              cssClass: "text-grey fill-current",
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: true,
          },
        },
        yaxis: {
          tickAmount: 5,
          title: {
            text: "Sales ( Qty )",
            // rotate: 90,
            offsetY: 0,
            offsetX: 0,
            style: { fontSize: "11px", cssClass: "" },
          },
          labels: {
            style: {
              cssClass: "text-grey fill-current",
            },
            formatter: function (val) {
              return val > 999 || val < -999
                ? (val / 1000).toFixed(1) + "k"
                : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
            },
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
      },
      chartOptionsBrush: {
        chart: {
          id: "chartBrush",
          brush: {
            target: "chartArea",
            enabled: true,
          },
          selection: {
            enabled: true,
            xaxis: {
              min: new Date(brushStart).getTime(),
              max: new Date(brushEnd).getTime(),
            },
          },
        },
        colors: ["#C8513C", themeColors[0]],
        grid: {
          // show: false,
          borderColor: "#e7e7e7",
          clipMarkers: false,
          yaxis: {
            lines: {
              show: false
            }
          },          
          // borderColor: "#e7e7e7",
        },
        fill: {
          gradient: {
            enabled: true,
            opacityFrom: 0.91,
            opacityTo: 0.1,
          },
        },
        legend: {
          show: false,
          // offsetY: 10
        },
        xaxis: {
          type: "datetime",
          tickAmount: 15,
          title: {
            offsetY: 10,
            text: "Week",
          },
          labels: {
            hideOverlappingLabels: true,
            style: {
              cssClass: "text-grey fill-current",
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: true,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          tickAmount: 2,
          axisTicks: {
            show: false,
          },
          labels: {
            style: {
              cssClass: "text-grey fill-current",
            },
            formatter: function (val) {
              return val > 999 || val < -999
                ? (val / 1000).toFixed(1) + "k"
                : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
            },
          },
        },
      },


      units: {
        category: {
          headers: [],
          data: []
        },
        sku: {
          headers: [],
          data: []
        }
      },
      topUnits: {
        count: 20,
        category: {
          label: "Categories",
          chartOptions: {},
          seriesData: []
        },
        sku: {
          label: "SKUs",
          chartOptions: {},
          seriesData: []
        }
      },
      trendBar: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          colors: [themeColors[0], "#C8513C"],
          chart: {
            toolbar: {
              show: false
            },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              columnWidth: "35%"
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: true,
            position: 'top',
            horizontalAlign: 'right'
          },
          grid: {
            show: false,
            borderColor: "#e7e7e7",
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 0],
            width: [2, 2]
          },
          xaxis: {
            labels: {
              show: false,
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            title: {
              text: this.type === 'category' ? "Categories" : "SKUs",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
            // categories: []
          },
          yaxis: {
            tickAmount: 5,
            title: {
              text: "Forecast "+this.artefact.mode === 'revenue' ? "Sales ( "+this.$options.filters.currencySymbol('')+" )" : "Quantity",

              // rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" },
            },
            labels: {
              style: {
                cssClass: "text-grey fill-current",
              },
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              },
            }
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: function(y) {
                if (typeof y !== "undefined") {
                  return y.toFixed(0);
                }
                return y;

              }
            }
          }
        }
      },
    };
  },
  computed: {},
  methods: {
// Sale Actual vs Forecast chart
    showTrend() {
      this.$vs.loading({
        // background: this.backgroundLoading,
        // color: this.colorLoading,
        container: "#demfor-charts",
        // scale: 0.45,
        type: "radius",
      });
      this.payload = {
        tags: this.artefact.tags,
        dateRange: this.dateScope(),
        query: this.artefact.query,
        mode: this.artefact.mode,
        type: "SDT",
      };

      fetchMock(this.payload)
        .then((response) => {
          this.series = this.buildStatsData(response.data.trend);
          // this.$vs.loading.close();
          this.$vs.loading.close("#demfor-charts > .con-vs-loading");
        })
        .catch((error) => {
          // this.$vs.loading.close();
          this.$vs.loading.close("#demfor-charts > .con-vs-loading");
          throw new Error(error);
        });
    },
    dateScope() {
      let dateScope = appCommons.allowedDateScope("", 365, 'minus');

      this.allowedDateScope = dateScope;
      let dateRange = {
        startDate: dateScope.startDate,
        endDate: dateScope.endDate,
      };

      return dateRange;
    },
    buildStatsData(trendData) {
      let series = [];

      for (let i = 0; i < this.artefact.tags.length; i++) {
        let filteredUnitDataTrend = {
          name: "",
          data: [],
        };
        let filteredUnitDataPredict = {
          name: "",
          data: [],
        };

        filteredUnitDataTrend.name = "Actual Sale";
        filteredUnitDataPredict.name = "Forecast Sale";

        let filteredActual = this.filterAndSortStatsData(
          this.artefact.tags[i],
          trendData,
          "actual"
        );

        let filteredPredict = this.filterAndSortStatsData(
          this.artefact.tags[i],
          trendData,
          "prediction"
        );

        let maxWeeksActual = filteredActual.length;
        let maxWeeksPredict = filteredPredict.length;
        if (maxWeeksActual > 0) {
          filteredUnitDataTrend.data = this.buildseriesOfStatsGroup(
            "actual",
            maxWeeksActual,
            filteredActual,
            filteredActual[0].sale_year
          );
          series.push(filteredUnitDataTrend);
        }
        if (maxWeeksPredict > 0) {
          filteredUnitDataPredict.data = this.buildseriesOfStatsGroup(
            "predicted",
            maxWeeksPredict,
            filteredPredict,
            filteredPredict[0].sale_year
          );
          series.push(filteredUnitDataPredict);
        }
      }

      return series;
    },
    filterAndSortStatsData(tag, data, type) {
      let filteredData = data.filter(
        t =>
          ((t.store_code
            ? tag.code === t.store_code
            : tag.tag === t.product_category) && 
          (type !== "prediction" ? t.type === type : true))
      );

      return filteredData.sort(function (t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        if (year1 < year2 && week1 < week2) {
          return -1;
        }
        if (year1 > year2 && week1 > week2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },
    buildseriesOfStatsGroup(type, maxWeeks, groupedUnit, startYear) {
      let series = [];
      let weekIndex = 0;
      let currentWeek = 1;
      let currentMonth = 0;
      let currentYear = startYear;
      let prevWeek = 100;

      while (weekIndex < maxWeeks) {
        if (groupedUnit[weekIndex]) {
          currentWeek = Number(groupedUnit[weekIndex].sale_week || 1);
          currentMonth = Number(groupedUnit[weekIndex].sale_month || 0);
          currentYear = groupedUnit[weekIndex].sale_year;

          let x = this.$moment()
            .isoWeekYear(currentYear)
            .isoWeek(currentWeek + 1)
            .startOf("isoWeek")
            .format("MM-DD-YYYY");

          let fieldToFetch = type + "_revenue";

          let y = groupedUnit[weekIndex].revenue
            ? groupedUnit[weekIndex].revenue || 0
            : groupedUnit[weekIndex][fieldToFetch] || 0;

          series.push({
            x: x,
            y: Math.floor(y),
          });
        } else {
          let x = this.$moment()
            .isoWeekYear(++currentYear)
            .isoWeek(currentWeek + 1)
            .startOf("isoWeek")
            .format("MM-DD-YYYY");

          let y = "0";

          currentWeek = currentWeek + 1;

          series.push({
            x: x,
            y: y,
          });
        }

        prevWeek = currentWeek;
        weekIndex++;
      }
      return series;
    },

// Top units chart

    fetchUnits(type, chartType) {
      this.units[type].data = this.formatItemsData(type);
      this.topUnits[type].chartOptions = this.chartOptions(type, chartType);
      this.topUnits[type].seriesData = this.seriesData(type, chartType);
    },
    formatItemsData(type) {
      let units = this.filterAndSortData(
        this.artefact.type,
        // this.items.res.order[type]
        this.artefact.mock.demand[type]
      );
      return units.reverse();
    },
    filterAndSortData(rtype, data) {
      let filteredData = data.filter(t =>
        rtype === 'SDF'
      );

      return filteredData.sort(function(t1, t2) {
        var upd1 = t1.revenue_sum;
        var upd2 = t2.revenue_sum;

        if (upd1 < upd2) {
          return -1;
        }
        if (upd1 > upd2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },
    chartOptions(type, chartType) {
      // let unitsData = this.units[type].data.slice(0, this.topUnits.count);
      let unitsData = this.units[type].data;
      let typeData = [];

      for (let i = 0; i < unitsData.length; i++) {
        if(type === "sku") {
          typeData.push(unitsData[i].sku_id + ' - ' +unitsData[i].desc);
        } else if(!typeData.includes(unitsData[i].cat_1)) {
          typeData.push(unitsData[i].cat_1);
        }

        if(this.topUnits.count < typeData.length) break;
      }

      if (chartType === "bar") {
        this.trendBar.chartOptions.xaxis.categories = typeData;
        return this.trendBar.chartOptions;
      } else if (chartType === "donut") {
        this.trendDonut.chartOptions.labels = typeData;
        return this.trendDonut.chartOptions;
      }
    },
    seriesData(type, chartType) {
      let modeLabel = this.artefact.mode === 'revenue' ? "Quantity" : "Sales ( "+this.$options.filters.currencySymbol('')+" )";
      let unitsData = this.units[type].data.slice(0, this.topUnits.count);
      let seriesData = [
        {
          name: "Forecast "+modeLabel,
          type: "column",
          data: []
        },
        {
          name: "Actual "+modeLabel,
          type: "column",
          data: []
        }
      ];

      for (let i = 0; i < unitsData.length; i++) {
        if (chartType === "bar" && unitsData[i].revenue_sum !== 0) {
          seriesData[0].data.push(Number(unitsData[i].revenue_sum));
          seriesData[1].data.push(Number(unitsData[i].revenue_sum) - (Math.floor(Math.random() * 2000)+1));
        } else if (chartType === "donut") {
          seriesData[0].data.push(Number(unitsData[i].revenue_sum));
        }
      }

      return seriesData;
    },   
  },
  created() {},
  mounted() {
    this.showTrend();
    this.fetchUnits(this.type, "bar");
  },
};
</script>

<style lang="scss">
</style>
